module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"move-up":"Переместить вверх","move-down":"Переместить вниз","clone":"Клонировать","view-the-code":"Смотреть код","delete":"Удалить"},"en":{"move-up":"Move up","move-down":"Move down","clone":"Clone","view-the-code":"View the code","delete":"Delete"}}')
  delete Component.options._Ctor
}
